export const SET_LOGIN_ACCOUNT = 'SET_LOGIN_ACCOUNT'
export const SET_ACCOUNT_PERMISSIONS = 'SET_ACCOUNT_PERMISSIONS'
